unit AbfKontrollePkt;

interface

uses System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,   JS, Web,
     Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebBasis2, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
     VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WEBLib.Controls, WEBLib.Dialogs,
     AbfKontrolleEdit, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
     VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.WebCtrls,
     VCL.TMSFNCEdit, GlobalWeb    ;

[async] function DoAbfKontrollePkt( var aObj : TObjAbfKon ) : TModalResult; async;

type
  TfrmAbfKontrollePkt = class(TfrmWebBasis2)
    WebPanel1: TPanel;
    lbAbfKonCaption: TLabel;
    lbPunkt: TLabel;
    btnSpeichern: TTMSFNCToolBarButton;
    fpFilePicker: TFilePicker;
    ImgContr: TImageControl;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnBildDel: TTMSFNCToolBarButton;
    WebPanel2: TPanel;
    mFehlerText: TMemo;
    btnDelBemerk: TTMSFNCToolBarButton;
    edtBildNr: TTMSFNCEdit;
    lbPunktParent: TLabel;
    WebLabel6: TLabel;
    WebLabel1: TLabel;
    cbxNOK: TCheckBox;
    procedure WebFormShow(Sender: TObject);
    procedure btnSpeichernClick(Sender: TObject);
    procedure fpFilePickerChange(Sender: TObject);
    procedure fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
    procedure Navigieren(Sender: TObject);
    procedure btnDelBemerkClick(Sender: TObject);
    procedure ImgContrDblClick(Sender: TObject);
    [async] procedure btnBildDelClick(Sender: TObject); async;
    procedure mFehlerTextChange(Sender: TObject);


  private
    aObjAbfKon : TObjAbfKon;
    function Bild_To_Array( sBildBase64, sBildName : String ) : Integer;
    function Bild_Entfernen( sBildBase64 : String ) : Integer;
    function Get_Bilder_Anzahl : Integer;
    function Get_Bild_NrByBase64( sBildBase64 : String ) : Integer;
    function Get_Bild_Nr( aNr : Integer ) : String;
    function Get_Bild_1st : String;
    function Set_BildInfo : Integer;
    procedure Form_Anpassen;

  public

  protected procedure LoadDFMValues; override; end;

var frmAbfKontrollePkt: TfrmAbfKontrollePkt;

implementation

{$R *.dfm}

uses UnitMain, Konstanten, SpediFucsDatenmodul,  GetStammdaten, ShowGrafik;


//====================================================================================================================//

function DoAbfKontrollePkt( var aObj : TObjAbfKon ) : TModalResult;
begin

  //Showmessage( aObj.BEZEICHNUNG );

  frmMainForm.mMainMenu.Enabled := False;

  frmAbfKontrollePkt := TfrmAbfKontrollePkt.Create(application);
  frmAbfKontrollePkt.Popup   := True;
  frmAbfKontrollePkt.iID_Sprache := frmMainForm.iID_Sprache;
  frmAbfKontrollePkt.aObjAbfKon  := aObj;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmAbfKontrollePkt, frmAbfKontrollePkt.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmAbfKontrollePkt.Resize;

  Try
    await( TModalResult, frmAbfKontrollePkt.Execute);  // excute form and wait for close

    Result := frmAbfKontrollePkt.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
        aObj.NOK := frmAbfKontrollePkt.cbxNOK.Checked;
        //await( frmAbfKontrollePkt.Daten_Speichern );
        //aID_AbfKon := frmAbfKontrollePkt.iID_AbfKon;
      End;
//
  Finally
    frmAbfKontrollePkt.Free;
  End;


  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.WebFormShow(Sender: TObject);
var iAnzBilder : Integer;
begin
  inherited;

  lbPunkt.Caption := self.aObjAbfKon.BEZEICHNUNG;
  lbPunktParent.Caption := self.aObjAbfKon.BezeichParent;
  mFehlerText.Text := self.aObjAbfKon.FehlerText;
  cbxNOK.Checked := aObjAbfKon.NOK;

  iAnzBilder := Get_Bilder_Anzahl;
  If iAnzBilder > 0 then
    Begin
      ImgContr.url := c_ImgVorsatz + Get_Bild_1st;
      Set_BildInfo;
    End;

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.btnSpeichernClick(Sender: TObject);
begin
  inherited;

  ModalResult := mrOK;

  aObjAbfKon.FehlerText   := mFehlerText.Text;
  aObjAbfKon.FehlerBilder := Get_Bilder_Anzahl;

  Close;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.btnBildDelClick(Sender: TObject);
var aModalResult : TModalResult;
    iAnzBilder, iBildNr : Integer;
    sBase64 : String;
begin
  inherited;

  aModalResult := await(TModalResult, MessageDlgAsync('Bild löschen ?', mtConfirmation, [mbYes, mbNo]));
  If aModalResult <> mrYes then Exit;

  // Bild-Vorsatz aus ImgContr.URL entfernen
  sBase64 := StringReplace( ImgContr.URL, c_ImgVorsatz, '', [rfReplaceAll]);

  Bild_Entfernen( sBase64 );

  ImgContr.URL := '';
  ImgContr.Clear;

  iAnzBilder := Get_Bilder_Anzahl;

console.log('AnzahlBilder: '+Inttostr(iAnzBilder));

  Set_BildInfo;

  If iAnzBilder > 0 then
    Begin
      ImgContr.url := c_ImgVorsatz + Get_Bild_1st;
      Set_BildInfo;
    End;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.btnDelBemerkClick(Sender: TObject);
begin
  inherited;
  mFehlerText.Lines.Clear;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.Form_Anpassen;
var iZielBreite : Integer;
begin



  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;

  // Komponenten
  iZielBreite := Trunc( self.Width * 0.95 );
  If iZielBreite > 500 then iZielBreite := 500;

  //lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.ImgContrDblClick(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );
end;

procedure TfrmAbfKontrollePkt.mFehlerTextChange(Sender: TObject);
begin
  inherited;
  If mFehlerText.Text <> '' then cbxNOK.Checked := True;

end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.fpFilePickerChange(Sender: TObject);
begin
  inherited;
  fpFilePicker.Files[0].GetFileAsBase64;
end;

//====================================================================================================================//

procedure TfrmAbfKontrollePkt.fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
var sBildDatei, sExt : String;
    aFile : TFile;
    iNr : Integer;
begin
  inherited;

  aFile := fpFilePicker.Files[AFileIndex];
  sExt  := UpperCase( ExtractFileExt(aFile.Name) );

  If (sExt='.PNG') or (sExt='.JPG') or (sExt='.JPEG') or (sExt='.BMP')  then
    Begin
      ImgContr.url := c_ImgVorsatz + ABase64;
      iNr := Bild_To_Array( ABase64, sExt );
      Set_BildInfo;
      cbxNOK.Checked := True;
    End;

end;

//====================================================================================================================//

function TfrmAbfKontrollePkt.Set_BildInfo : Integer;
var iBildNr : Integer;
    sBase64 : String;
begin

  // Bild-Vorsatz aus ImgContr.URL entfernen
  sBase64 := StringReplace( ImgContr.URL, c_ImgVorsatz, '',  [rfReplaceAll] );

  iBildNr := self.Get_Bild_NrByBase64( sBase64 );

  edtBildNr.Text := 'Bild: ' + IntToStr(iBildNr)+' / ' + IntToStr(Get_Bilder_Anzahl);


end;

//====================================================================================================================//

function TfrmAbfKontrollePkt.Bild_To_Array( sBildBase64, sBildName : String ) : Integer;
var i : Integer;
begin

  Result := 0;

  For i := 1 to c_MaxAnzBilder Do
    Begin
      If Trim(aObjAbfKon.BilderDaten[i]) = '' then
        Begin
          aObjAbfKon.BilderDaten[i] := sBildBase64;
          aObjAbfKon.BilderName[i]  := sBildName;
          Result := i;
          Break;
        End;
    End;

end;

//====================================================================================================================//

function TfrmAbfKontrollePkt.Get_Bilder_Anzahl : Integer;
var i : Integer;
begin

  Result := 0;

  For i := 1 to c_MaxAnzBilder Do
   If Trim(aObjAbfKon.BilderDaten[i]) <> '' then Inc(Result);

end;

//====================================================================================================================//
// das n-te Bild im Array

function TfrmAbfKontrollePkt.Get_Bild_NrByBase64( sBildBase64 : String ) : Integer;
var i  : Integer;
begin

  Result := 0;

  If sBildBase64='' then Exit;

  For i := 1 to c_MaxAnzBilder Do
   Begin
     If Trim(aObjAbfKon.BilderDaten[i]) <> '' then Inc(Result);
     If Trim(aObjAbfKon.BilderDaten[i]) = sBildBase64 then Break;
   End;
end;

//====================================================================================================================//


function TfrmAbfKontrollePkt.Get_Bild_Nr( aNr : Integer ) : String;
var i, iLfd : Integer;
begin

  Result := '';
  iLfd := 0;

  For i := 1 to c_MaxAnzBilder Do
    Begin
      If Trim(aObjAbfKon.BilderDaten[i]) <> '' then
        Begin
          Inc(iLfd);
          If iLfd = aNr then
            Begin
              Result :=aObjAbfKon.BilderDaten[i];
              Break;
            End;
        End;
    End;

end;


//====================================================================================================================//
// Bild aus Array löschen

function TfrmAbfKontrollePkt.Bild_Entfernen( sBildBase64 : String ) : Integer;
var i  : Integer;
begin

  Result := 0;

  If sBildBase64='' then Exit;

  For i := 1 to c_MaxAnzBilder Do
   Begin
     If Trim(aObjAbfKon.BilderDaten[i]) = sBildBase64 then
       Begin
         aObjAbfKon.BilderDaten[i] := '';
         aObjAbfKon.BilderName[i]  := '';
       End;
   End;
end;

//====================================================================================================================//

function TfrmAbfKontrollePkt.Get_Bild_1st : String;
var i, iLfd : Integer;
begin

  Result := '';
  iLfd := 0;

  For i := 1 to c_MaxAnzBilder Do
    If Trim(aObjAbfKon.BilderDaten[i]) <> '' then
      Begin
        Result :=aObjAbfKon.BilderDaten[i];
        Break;
      End;

end;


//====================================================================================================================//

procedure TfrmAbfKontrollePkt.Navigieren(Sender: TObject);
var iAnz, iBildNr : Integer;
    sBase64 : String;
begin
  inherited;

  iAnz := Get_Bilder_Anzahl;
  If iAnz=0 then Exit;

  sBase64 := StringReplace( ImgContr.URL, c_ImgVorsatz, '',  [rfReplaceAll] );
  iBildNr := Get_Bild_NrByBase64( sBase64 );

  If Sender = btnNavNext then
    Begin
      If iBildNr = iAnz then Exit;
      Inc(iBildNr);
      ImgContr.url :=  c_ImgVorsatz + Get_Bild_Nr( iBildNr );
      Set_BildInfo;
    End
  Else
    Begin
      If iBildNr = 1 then Exit;
      Dec(iBildNr);
      ImgContr.url := c_ImgVorsatz + Get_Bild_Nr( iBildNr );
      Set_BildInfo;
    End;

end;

//====================================================================================================================//


procedure TfrmAbfKontrollePkt.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ImgContr := TImageControl.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  lbAbfKonCaption := TLabel.Create(Self);
  lbPunkt := TLabel.Create(Self);
  lbPunktParent := TLabel.Create(Self);
  btnSpeichern := TTMSFNCToolBarButton.Create(Self);
  cbxNOK := TCheckBox.Create(Self);
  fpFilePicker := TFilePicker.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnBildDel := TTMSFNCToolBarButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  mFehlerText := TMemo.Create(Self);
  btnDelBemerk := TTMSFNCToolBarButton.Create(Self);
  edtBildNr := TTMSFNCEdit.Create(Self);

  ImgContr.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WaitMessage.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbAbfKonCaption.BeforeLoadDFMValues;
  lbPunkt.BeforeLoadDFMValues;
  lbPunktParent.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  cbxNOK.BeforeLoadDFMValues;
  fpFilePicker.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnBildDel.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  mFehlerText.BeforeLoadDFMValues;
  btnDelBemerk.BeforeLoadDFMValues;
  edtBildNr.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 397;
    Height := 466;
    Caption := 'frmAbfKontrollePkt';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ImgContr.SetParentComponent(Self);
    ImgContr.Name := 'ImgContr';
    ImgContr.Left := 6;
    ImgContr.Top := 336;
    ImgContr.Width := 383;
    ImgContr.Height := 130;
    ImgContr.WidthStyle := ssAuto;
    ImgContr.HeightPercent := 100.000000000000000000;
    ImgContr.WidthPercent := 100.000000000000000000;
    ImgContr.Anchors := [akLeft,akTop,akRight,akBottom];
    ImgContr.ChildOrder := 1;
    SetEvent(ImgContr, Self, 'OnDblClick', 'ImgContrDblClick');
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 103;
    WebLabel6.Width := 397;
    WebLabel6.Height := 20;
    WebLabel6.Align := alTop;
    WebLabel6.Alignment := taCenter;
    WebLabel6.AutoSize := False;
    WebLabel6.Caption := ' Bemerkung';
    WebLabel6.Color := 12021811;
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWhite;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Verdana';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.Transparent := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 228;
    WebLabel1.Width := 397;
    WebLabel1.Height := 20;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := ' Fotos';
    WebLabel1.Color := 12021811;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWhite;
    WebLabel1.Font.Height := -13;
    WebLabel1.Font.Name := 'Verdana';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.Transparent := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WaitMessage.Left := 115;
    WaitMessage.Top := 164;
    BitmapCont.Left := 361;
    BitmapCont.Top := 250;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 397;
    WebPanel1.Height := 103;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 2;
    lbAbfKonCaption.SetParentComponent(WebPanel1);
    lbAbfKonCaption.Name := 'lbAbfKonCaption';
    lbAbfKonCaption.Left := 97;
    lbAbfKonCaption.Top := 6;
    lbAbfKonCaption.Width := 143;
    lbAbfKonCaption.Height := 18;
    lbAbfKonCaption.Caption := 'Abfahrtskontrolle';
    lbAbfKonCaption.Font.Charset := DEFAULT_CHARSET;
    lbAbfKonCaption.Font.Color := clBlack;
    lbAbfKonCaption.Font.Height := -15;
    lbAbfKonCaption.Font.Name := 'Verdana';
    lbAbfKonCaption.Font.Style := [fsBold];
    lbAbfKonCaption.HeightPercent := 100.000000000000000000;
    lbAbfKonCaption.ParentFont := False;
    lbAbfKonCaption.WidthPercent := 100.000000000000000000;
    lbPunkt.SetParentComponent(WebPanel1);
    lbPunkt.Name := 'lbPunkt';
    lbPunkt.Left := 8;
    lbPunkt.Top := 78;
    lbPunkt.Width := 71;
    lbPunkt.Height := 16;
    lbPunkt.Caption := 'T0000000';
    lbPunkt.Font.Charset := ANSI_CHARSET;
    lbPunkt.Font.Color := clWindowText;
    lbPunkt.Font.Height := -13;
    lbPunkt.Font.Name := 'Verdana';
    lbPunkt.Font.Style := [fsBold];
    lbPunkt.HeightPercent := 100.000000000000000000;
    lbPunkt.ParentFont := False;
    lbPunkt.WidthPercent := 100.000000000000000000;
    lbPunktParent.SetParentComponent(WebPanel1);
    lbPunktParent.Name := 'lbPunktParent';
    lbPunktParent.Left := 8;
    lbPunktParent.Top := 56;
    lbPunktParent.Width := 71;
    lbPunktParent.Height := 16;
    lbPunktParent.Caption := 'T0000000';
    lbPunktParent.Font.Charset := ANSI_CHARSET;
    lbPunktParent.Font.Color := clWindowText;
    lbPunktParent.Font.Height := -13;
    lbPunktParent.Font.Name := 'Verdana';
    lbPunktParent.Font.Style := [fsBold];
    lbPunktParent.HeightPercent := 100.000000000000000000;
    lbPunktParent.ParentFont := False;
    lbPunktParent.WidthPercent := 100.000000000000000000;
    btnSpeichern.SetParentComponent(WebPanel1);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 4;
    btnSpeichern.Top := 6;
    btnSpeichern.Width := 87;
    btnSpeichern.Height := 44;
    btnSpeichern.Cursor := crHandPoint;
    btnSpeichern.ParentDoubleBuffered := False;
    btnSpeichern.DoubleBuffered := True;
    btnSpeichern.Font.Charset := ANSI_CHARSET;
    btnSpeichern.Font.Color := clWindowText;
    btnSpeichern.Font.Height := -13;
    btnSpeichern.Font.Name := 'Verdana';
    btnSpeichern.Font.Style := [];
    btnSpeichern.ParentColor := True;
    btnSpeichern.TabOrder := 0;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    btnSpeichern.Text := '';
    btnSpeichern.TextVisible := False;
    btnSpeichern.Bitmaps.Clear;
    with btnSpeichern.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnSpeichern.BitmapVisible := True;
    btnSpeichern.BitmapContainer := BitmapCont;
    btnSpeichern.ControlIndex := 0;
    cbxNOK.SetParentComponent(WebPanel1);
    cbxNOK.Name := 'cbxNOK';
    cbxNOK.Left := 132;
    cbxNOK.Top := 31;
    cbxNOK.Width := 65;
    cbxNOK.Height := 22;
    cbxNOK.Caption := 'NOK';
    cbxNOK.ChildOrder := 4;
    cbxNOK.Font.Charset := ANSI_CHARSET;
    cbxNOK.Font.Color := clWindowText;
    cbxNOK.Font.Height := -15;
    cbxNOK.Font.Name := 'Verdana';
    cbxNOK.Font.Style := [fsBold];
    cbxNOK.HeightPercent := 100.000000000000000000;
    cbxNOK.ParentFont := False;
    cbxNOK.WidthPercent := 100.000000000000000000;
    fpFilePicker.SetParentComponent(Self);
    fpFilePicker.Name := 'fpFilePicker';
    fpFilePicker.Left := 0;
    fpFilePicker.Top := 248;
    fpFilePicker.Width := 397;
    fpFilePicker.Height := 40;
    fpFilePicker.Accept := 'image/*';
    fpFilePicker.Align := alTop;
    fpFilePicker.ChildOrder := 1;
    SetEvent(fpFilePicker, Self, 'OnChange', 'fpFilePickerChange');
    SetEvent(fpFilePicker, Self, 'OnGetFileAsBase64', 'fpFilePickerGetFileAsBase64');
    btnNavPrev.SetParentComponent(Self);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 8;
    btnNavPrev.Top := 290;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 4;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Navigieren');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(Self);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 74;
    btnNavNext.Top := 290;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 5;
    SetEvent(btnNavNext, Self, 'OnClick', 'Navigieren');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnBildDel.SetParentComponent(Self);
    btnBildDel.Name := 'btnBildDel';
    btnBildDel.Left := 273;
    btnBildDel.Top := 290;
    btnBildDel.Width := 65;
    btnBildDel.Height := 44;
    btnBildDel.Cursor := crHandPoint;
    btnBildDel.ParentDoubleBuffered := False;
    btnBildDel.DoubleBuffered := True;
    btnBildDel.Font.Charset := ANSI_CHARSET;
    btnBildDel.Font.Color := clWindowText;
    btnBildDel.Font.Height := -13;
    btnBildDel.Font.Name := 'Verdana';
    btnBildDel.Font.Style := [];
    btnBildDel.ParentColor := True;
    btnBildDel.TabOrder := 6;
    SetEvent(btnBildDel, Self, 'OnClick', 'btnBildDelClick');
    btnBildDel.Text := '';
    btnBildDel.TextVisible := False;
    btnBildDel.Bitmaps.Clear;
    with btnBildDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnBildDel.BitmapVisible := True;
    btnBildDel.BitmapContainer := BitmapCont;
    btnBildDel.ControlIndex := 0;
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 123;
    WebPanel2.Width := 397;
    WebPanel2.Height := 105;
    WebPanel2.Align := alTop;
    WebPanel2.ChildOrder := 10;
    WebPanel2.Color := 16776441;
    WebPanel2.TabOrder := 7;
    mFehlerText.SetParentComponent(WebPanel2);
    mFehlerText.Name := 'mFehlerText';
    mFehlerText.Left := 0;
    mFehlerText.Top := 0;
    mFehlerText.Width := 397;
    mFehlerText.Height := 105;
    mFehlerText.Align := alClient;
    mFehlerText.Font.Charset := ANSI_CHARSET;
    mFehlerText.Font.Color := clWindowText;
    mFehlerText.Font.Height := -13;
    mFehlerText.Font.Name := 'Verdana';
    mFehlerText.Font.Style := [];
    mFehlerText.HeightPercent := 100.000000000000000000;
    mFehlerText.ParentFont := False;
    mFehlerText.SelLength := 0;
    mFehlerText.SelStart := 0;
    mFehlerText.SpellCheck := False;
    mFehlerText.WidthPercent := 100.000000000000000000;
    SetEvent(mFehlerText, Self, 'OnChange', 'mFehlerTextChange');
    btnDelBemerk.SetParentComponent(WebPanel2);
    btnDelBemerk.Name := 'btnDelBemerk';
    btnDelBemerk.Left := 308;
    btnDelBemerk.Top := 3;
    btnDelBemerk.Width := 65;
    btnDelBemerk.Height := 44;
    btnDelBemerk.Cursor := crHandPoint;
    btnDelBemerk.ParentDoubleBuffered := False;
    btnDelBemerk.Anchors := [akTop,akRight];
    btnDelBemerk.DoubleBuffered := True;
    btnDelBemerk.Font.Charset := ANSI_CHARSET;
    btnDelBemerk.Font.Color := clWindowText;
    btnDelBemerk.Font.Height := -13;
    btnDelBemerk.Font.Name := 'Verdana';
    btnDelBemerk.Font.Style := [];
    btnDelBemerk.ParentColor := True;
    btnDelBemerk.TabOrder := 1;
    SetEvent(btnDelBemerk, Self, 'OnClick', 'btnDelBemerkClick');
    btnDelBemerk.Text := '';
    btnDelBemerk.TextVisible := False;
    btnDelBemerk.Bitmaps.Clear;
    with btnDelBemerk.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnDelBemerk.BitmapVisible := True;
    btnDelBemerk.BitmapContainer := BitmapCont;
    btnDelBemerk.ControlIndex := 0;
    edtBildNr.SetParentComponent(Self);
    edtBildNr.Name := 'edtBildNr';
    edtBildNr.Left := 145;
    edtBildNr.Top := 290;
    edtBildNr.Width := 121;
    edtBildNr.Height := 44;
    edtBildNr.Alignment := taCenter;
    edtBildNr.AutoSize := False;
    edtBildNr.ParentColor := True;
    edtBildNr.ReadOnly := True;
    edtBildNr.TabOrder := 8;
    edtBildNr.Text := 'Bild: 0 / 0';
    edtBildNr.Lookup.Separator := ';';
    tabSprachDaten.Left := 112;
    tabSprachDaten.Top := 368;
  finally
    ImgContr.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WaitMessage.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbAbfKonCaption.AfterLoadDFMValues;
    lbPunkt.AfterLoadDFMValues;
    lbPunktParent.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    cbxNOK.AfterLoadDFMValues;
    fpFilePicker.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnBildDel.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    mFehlerText.AfterLoadDFMValues;
    btnDelBemerk.AfterLoadDFMValues;
    edtBildNr.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
